// Product Rankings: add the #1 pick to cart, tagged for attribution, then open the theme's cart popup.
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-picks-add]');
  if (!btn || btn.disabled) return;
  const card = btn.closest('.picks-card');
  const err = card?.querySelector('[data-picks-error]');
  const label = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';
  if (err) err.hidden = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1, properties: { _source: 'picks-card' } }] }),
    });
    if (!res.ok) throw new Error('add failed ' + res.status);
  } catch (ex) {
    console.error('[picks-ranking]', ex);
    if (err) err.hidden = false;
    btn.textContent = label;
    btn.disabled = false;
    return;
  }
  // The item is in the cart now; a failed refresh must not invite a duplicate add.
  try {
    const cart = await fetch('/cart.js').then((r) => r.json());
    // Look up the live element like the theme's ajaxCart does: window.cartPopup can be a stale, detached instance on mobile.
    const popup = document.querySelector('cart-popup') || window.cartPopup;
    if (!popup) throw new Error('no cart popup');
    popup.renderContents(cart);
    btn.textContent = '✓ Added';
    setTimeout(() => { btn.textContent = label; btn.disabled = false; }, 1500);
  } catch (ex) {
    console.error('[picks-ranking] cart refresh', ex);
    window.location.href = '/cart';
  }
});
